<template>
    <modal
        class="add-category-modal"
        name="add-category-modal"
        @before-close="resetComponent"
        @before-open="setProps"
        transition="fade"
        :adaptive="true"
        :scrollable="true"
        :reset="true"
        width="70%"
        height="80%"
    >
        <div id="modal-header">
            <div class="w-75 d-flex">
                <p>Ընտրել Կատեգորիա</p>
            </div>
            <button
                type="button"
                class="close position-absolute"
                style="right: 1.25rem; top: 25%"
                @click="$modal.hide('add-category-modal')"
                aria-label="Close"
            >
                <svg
                    width="17"
                    height="16"
                    viewBox="0 0 17 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M16.5 1.64102L14.859 0L8.49997 6.359L2.14102 4.62582e-05L0.5 1.64107L6.85895 8.00002L0.500034 14.3589L2.14105 16L8.49997 9.64104L14.8589 16L16.5 14.359L10.141 8.00002L16.5 1.64102Z"
                        fill="#ABAEB8"
                    />
                </svg>
            </button>
        </div>
        <div id="modal-body">
            <div
                class="d-flex flex-wrap gap-2 padding-r-10 padding-l-10 padding-t-20 padding-b-20"
            >
                <category-card
                    :category="category"
                    :selectedCategory="selectedCategory"
                    @clickMethod="handleSelectCategory"
                    :show-count="false"
                    v-for="(category, index) in timelessTendersCategories"
                    :key="index"
                />
            </div>
        </div>
        <div id="modal-footer">
            <button :disabled="!selectedCategory?.value" @click="addRows" type="button" class="btn btn-primary">
                <span>Ավելացնել</span>
            </button>
        </div>
    </modal>
</template>

<script>
import CategoryCard from '@/components/timelessTenders/categoryCard.vue'

export default {
    name: 'AddCategoryModal',
    components: {CategoryCard},
    data() {
        return this.getComponentInitialData();
    },
    computed: {
        me() {
            return this.$store.getters['user/me']
        },
        timelessTendersCategories() {
            return this.$store.getters['settings/timelessTendersCategories']
        },
    },
    methods: {
        handleSelectCategory(category) {
            this.selectedCategory = category
        },
        getComponentInitialData() {
            return {
                selectedCategory: { },
                cpvSpecs: [],
                handleAddCategory: undefined,
            }
        },
        resetComponent() {
            Object.assign(this.$data, this.getComponentInitialData())
        },
        setProps({ params }) {
            this.handleAddCategory = params
        },
        addRows() {
            this.handleAddCategory(this.selectedCategory)
            this.$modal.hide('add-category-modal')
        },
        consoleLog(msg) {
            console.log(typeof msg, 'sdlkjflsk')
        },
    },
}
</script>

<style scoped></style>
